export default [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '../pages/HomePage.vue'),
        meta: {
            title: 'HOME',
            icon: 'mdi-home-outline',
            gtm: 'home'
        }
    }
]
